import _ from 'lodash'
import {createContext, FC, useContext, useState} from 'react'

import {useRouter} from '@/utils/hooks/useRouter'

type MarketsModalContextType = {
  isMarketsModalVisible: boolean
  setIsMarketsModalVisible: (value: boolean) => void
}

const MarketsModalContext = createContext<MarketsModalContextType>({
  isMarketsModalVisible: false,
  setIsMarketsModalVisible: _.identity,
})

export const useMarketsModalContext = (): MarketsModalContextType => useContext(MarketsModalContext)

export const MarketsModalProvider: FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const router = useRouter()
  const hasCountryQuery = !!router.query?.country
  const [isMarketsModalVisible, setIsMarketsModalVisible] = useState(hasCountryQuery)

  return (
    <MarketsModalContext.Provider value={{isMarketsModalVisible, setIsMarketsModalVisible}}>
      {children}
    </MarketsModalContext.Provider>
  )
}
